import React, { useEffect } from 'react';
import Header from './Header';
import Nav from './Nav';

const About = () => {
  useEffect(() => {
    new window.pym.Parent('about-iframe-container', 'assets/about.html', {}); //eslint-disable-line
  });
  return (
    <div>
      <Header />
      <Nav />
      <div id="about-iframe-container" style={{ overflow: 'hidden' }} />
    </div>
  );
};

export default About;
